var t="@hpstellar/core/attachable-product-tile";export{t as attachableProductTileTestId};
